import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgramPageStatusService {
  private _isDirty = false;

  constructor() { }

  set isDirty(status: boolean) {
    this._isDirty = status;
  }

  get isDirty() {
    return this._isDirty;
  }

  public reset() {
    this._isDirty = false;
  }
}
